<template>
    <v-card hover raised class="text-xs-center card-scrollable">
        <v-card-title primary-title clor="primary">
            <h3 class="headline mb-0">Actualizaciones del sistema</h3>
        </v-card-title>
        <v-card-text>
            <v-list three-line>
                <template v-for="c in commits">
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ c.created_at | tiempo }} | {{ c.title }}</v-list-tile-title>
                            <v-list-tile-sub-title v-html="c.message"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                </template>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
    import moment from 'moment';
    moment.locale('es');
    export default {
        name: "misPresupuestos",
        filters: {
            tiempo(v) {
                return moment(v).fromNow();
            }
        },
        data() {
            return {
                loading: false,
                commits: []
            }
        },
        mounted() {
            this.datos()
        },
        methods: {
            datos() {
                this.loading = true;
                this.$http.post('/gitlab/commits')
                    .then(r => {
                        this.commits = r.data;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
            }
        }
    }
</script>
<style scoped>
    .card-scrollable .v-card__text {
        overflow-y: auto;
        height: 300px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/ActualizacionesSistema.vue